module.exports = __webpack_public_path__ + "static/implant-screw-b1124392e9733e5da53b2bf2488327f2.jpg";